import React, { useState } from "react";
import AptCard from "./aptcard";
import CreateAppointment from "./createAppointment";
import VisitStatus from "./visitstatus";
import ProvidersStatus from "./providersstatus";
import Payment from "./payment";
import Checkout from "./checkout";
import ProviderModal from "./Providermodal";
import RoomPopup from "./RoomChange";
import PurposeModal from "./PurposeModal";



const ModalSwitch = ({ isAptcard,screen,setScreen ,flow='',setIsAptcard,isfutureappointment,setIsFutureAppointment,fetchScheduleData ,selectedDate, selectedAppointment ,appointmentCardopen,setIsappointmentCardOpen }) => {
 const [orderData,setOrderData]=useState(null)
const [navigateto,setNavigateTo]=useState(0)
  const [orderOptions, setOrderOptions] = useState([]);

  const closeAllModals = () => {
    setIsAptcard(false);  // This will hide the AptCard screen
    setScreen(0);  // This resets the screen to 0
  };
  if (!isAptcard) return null;
  const renderScreen = () => {
    switch (screen) {
      case 0:
        return <AptCard isfutureappointment={isfutureappointment} setScreen={setScreen}  selectedAppointment={selectedAppointment}  setIsAptcard={setIsAptcard} />;
    case 1:
      setIsappointmentCardOpen(true);
      return <CreateAppointment 
      isfutureappointment={isfutureappointment} 
        selectedDate={selectedDate} 
      fetchScheduleData={fetchScheduleData}
         setIsAptcard={setIsAptcard} 
      setNavigateTo={setNavigateTo}
       setOrderData={setOrderData}
        orderData={orderData}
       setScreen={setScreen} 
       flow=''
       selectedAppointment={selectedAppointment} 
        appointmentCardopen={appointmentCardopen} />
      case 2:
        return <VisitStatus setIsAptcard={setIsAptcard} selectedDate={selectedDate} fetchScheduleData={fetchScheduleData}  selectedAppointment={selectedAppointment} setScreen={setScreen} closeAllModals={closeAllModals} />
        case 3:
          return <Payment closeAllModals={setScreen} data={selectedAppointment} />
          case 4:
            return <Checkout selectedDate={selectedDate} fetchScheduleData={fetchScheduleData}   setIsAptcard={setIsAptcard}  navigateto={navigateto} setScreen={setScreen} orderData={orderData} closeAllModals={setScreen} selectedAppointment={selectedAppointment} />
            case 5:
              return <ProviderModal selectedDate={selectedDate} fetchScheduleData={fetchScheduleData}  selectedAppointment={selectedAppointment} setScreen={setScreen} closeAllModals={closeAllModals} />
              case 6:
                return <RoomPopup selectedDate={selectedDate} fetchScheduleData={fetchScheduleData}  selectedAppointment={selectedAppointment}  setScreen={setScreen}  closeAllModals={closeAllModals}/>
                case 7:
                  return <PurposeModal selectedDate={selectedDate} fetchScheduleData={fetchScheduleData}  selectedAppointment={selectedAppointment}  setScreen={setScreen} closeAllModals={closeAllModals} />
      default:
        return <div>Something Went wrong .</div>;
    }
  };

  return <>{renderScreen()}</>;
};

export default ModalSwitch;
